import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M12.785 13.857a3.928 3.928 0 100-7.857 3.928 3.928 0 000 7.857zM18.142 24.926a.357.357 0 00-.357-.358 3.214 3.214 0 01-1.428-6.114.372.372 0 00.2-.3.344.344 0 00-.157-.328 6.543 6.543 0 00-3-1.086A6.785 6.785 0 006 23.497v1.071a1.428 1.428 0 001.428 1.429h10.428a.315.315 0 00.272-.129.386.386 0 00.086-.3 3.292 3.292 0 01-.072-.642z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M25.998 21.355a1.086 1.086 0 00-1.072-1.071h-2.142a.357.357 0 01-.358-.357v-2.143a1.071 1.071 0 10-2.142 0v2.143a.357.357 0 01-.357.357h-2.143a1.071 1.071 0 100 2.142h2.143a.357.357 0 01.357.358v2.142a1.071 1.071 0 002.142 0v-2.142a.357.357 0 01.358-.358h2.142a1.086 1.086 0 001.072-1.071z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
